import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SPHeader = _resolveComponent("SPHeader")!
  const _component_PCHeader = _resolveComponent("PCHeader")!

  return (_ctx.isSP)
    ? (_openBlock(), _createBlock(_component_SPHeader, { key: 0 }))
    : (_openBlock(), _createBlock(_component_PCHeader, { key: 1 }))
}